var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3089 0.03125C23.4272 0.03125 0.324219 0.186068 0.324219 0.03125C0.324219 0.03125 0.324219 19.764 0.324219 22.3929C0.324219 25.3237 3.57679 25.9081 3.87325 25.9555C3.89855 26.1956 4.34504 29.8086 8.39781 29.8086C10.4164 29.8086 33.6748 29.8086 33.6748 29.8086C33.6748 29.8086 33.6748 10.1701 33.6748 6.52582C33.6748 2.35113 31.1905 0.03125 27.3089 0.03125ZM7.91938 20.5873H5.67488C5.67488 20.5873 5.67488 12.9106 5.67488 11.6474C5.67488 9.02392 7.91938 9.02392 7.91938 9.02392V20.5879V20.5873ZM26.4051 20.5873V9.02392H16.3431C16.4865 9.02692 18.5797 9.11393 18.5797 11.6474V20.5873H16.3352V9.02392H7.94529C7.94529 9.02392 7.94529 6.78866 10.5796 6.78866H13.5436C15.5386 6.78866 16.0225 8.06981 16.1406 8.69208C16.2581 8.06981 16.7425 6.78866 18.7376 6.78866H23.8237C26.4581 6.78866 26.4581 9.02392 26.4581 9.02392H26.4129C26.5563 9.02692 28.649 9.11393 28.649 11.6474C28.649 12.9106 28.649 20.5873 28.649 20.5873H26.4045H26.4051Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.36b7cbb85d71eb223f55fe44638b2dee.svg";
export { ForwardRef as ReactComponent };